<div class="card-body">
  <div style="display:flex; justify-content:space-between;">
    <h2 class="card-title">Comentários</h2>
    <button style="border: none; background: none;" type="button" class="modal-description__close"
      (click)="closeModal()">
      <mat-icon style="margin: 0px; padding: 0px" color="primary">close</mat-icon>
    </button>
  </div>
  <ul class="list-unstyled list-group">
    <div *ngIf="!denounce.op_comments" class="list-group-item">
      <div class="wrapper-attachment" style="display: flex; justify-content: center;">
        <b>Não existe comentário nessa denúncia</b>
      </div>
    </div>
    <li *ngFor="let comment of denounce.op_comments; let i = index">
      <div class="list-group-item">
        <div style="display: flex; justify-content: space-between;">
          <b style="font-size: 0.8rem">{{ comment.user_name }}</b>
          <b style="font-size: 0.8rem">{{ comment.datetime | date: "dd/MM/yy HH:mm"}}</b>
        </div>
        <div class="wrapper-attachment" style="display: flex; justify-content: space-between;">
          {{ comment.message }}
          <button mat-icon-button (click)="deleteComment(comment.datetime)">
            <span class="material-icons">delete</span>
          </button>
        </div>
      </div>
    </li>
  </ul>
</div>